<template>
  <div
    class="corner-ribbon top-left sticky"
    :style="ribbonColors"
  >{{ text }}</div>
</template>

<style>
/* The ribbons */

.corner-ribbon {
    width: 200px;
    background: #73B315;
    position: absolute;
    top: 25px;
    left: -50px;
    text-align: center;
    line-height: 30px;
    color: #f0f0f0;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    z-index: 2000;
}

/* Custom styles */

.corner-ribbon.sticky {
    position: fixed;
}

.corner-ribbon.shadow {
    
}

/* Different positions */

.corner-ribbon.top-left {
    top: 25px;
    left: -60px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
}

.corner-ribbon.top-right {
    top: 25px;
    right: -50px;
    left: auto;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
}

.corner-ribbon.bottom-left {
    top: auto;
    bottom: 25px;
    left: -50px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
}

.corner-ribbon.bottom-right {
    top: auto;
    right: -50px;
    bottom: 25px;
    left: auto;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
}
</style>


<script>

export default {
  name: 'corner-ribbon',
  props: ['text'],
  data: () => ({
    presets: {
      dev: { background: "#73B315" },
      stage: { background: "#73B315" },
      test: { background: "rgba(255, 196, 61, 1)" },
      prod: { background: "rgba(239, 71, 111, 1)" },
    }
  }),
  computed: {
    ribbonColors() {
      if (!this.text) {
        return {background: '#000', color: '#000'}
      }
      if (this.presets[this.text]) {
        return this.presets[this.text]
      }

      var str = this.text
      var hash = 0;
      for (var i = 0; i < str.length; i++) {
          hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      var colour = '#';
      var brightness = 0;
      for (var i = 0; i < 3; i++) {
          var value = (hash >> (i * 8)) & 0xFF;
          brightness += value * ([0.299, 0.587, 0.114])[i]
          colour += ('00' + value.toString(16)).substr(-2);
      }
      return {background: colour}
    },
  }
}
</script>
